import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { HankoAuth } from "../components/HankoAuth";
import { useAuth } from "../context/AuthContext";
import "../styles/hanko.css";

export function Login() {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated && !isLoading) {
      navigate("/dashboard");
    }
  }, [isAuthenticated, isLoading, navigate]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <span className="material-symbols-outlined text-4xl animate-spin text-primary">progress_activity</span>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen p-4 bg-background">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <div className="flex items-center gap-3">
            <div className="size-12 flex items-center justify-center rounded-xl bg-primary text-primary-foreground shadow-lg">
              <span className="material-symbols-outlined text-3xl">deployed_code</span>
            </div>
            <div>
              <h1 className="text-2xl font-black tracking-tight">BuildCrate</h1>
              <p className="text-xs text-muted-foreground">buildcrate.games</p>
            </div>
          </div>
        </div>

        {/* Card */}
        <div className="bg-card border border-border rounded-xl shadow-lg p-8">
          <div className="text-center mb-6">
            <h2 className="text-2xl font-bold mb-2">Welcome Back</h2>
            <p className="text-muted-foreground">Sign in to manage your game builds</p>
          </div>

          <HankoAuth />

          <p className="text-center text-sm text-muted-foreground mt-6">
            Don't have an account?{" "}
            <Link to="/signup" className="text-primary font-medium hover:underline">
              Sign up
            </Link>
          </p>
        </div>

        <p className="text-center text-xs text-muted-foreground mt-6">
          By signing in, you agree to our Terms of Service and Privacy Policy
        </p>
      </div>
    </div>
  );
}
